import { Tooltip, Box } from '@mui/material';
import jMoment from 'moment-jalaali';
import { TableItemActionsNew, Icons } from 'components';
const DescriptionStatus = (status, description) => {
  const statusList = {
    pending: 'در انتظار تایید', // unpublish
    accepted: 'تایید شده', // unpublish  - no edit
    rejected: 'تایید نشده', // publish
    draft: 'پیش نویس', // publish
    deleted: 'حذف شده', // - no edit
  };

  return (
    <Tooltip placement="top-start" color="primary" title={description || ''}>
      <div style={{ textAlign: 'center', display: 'block' }}>
        {status in statusList ? statusList[status] : ''}
      </div>
    </Tooltip>
  );
};

const columns = (actionsList, navigate, requestPublish, requestUnpublish) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'تاریخ ایجاد',
    field: 'createdAt',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rc) => (rc?.createdAt ? jMoment(rc.createdAt).format('dddd, jD jMMMM jYYYY') : '-'),
  },
  {
    title: 'نام مجموعه سرویس',
    field: 'name',
    filtering: false,
    sorting: false,
    align: 'center',
  },
  {
    title: 'وب سرویس‌ها',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) => {
      const webservices =
        row?.webservices && row.webservices.length
          ? row.webservices.map((item) => item.name).join(', ')
          : '';

      return (
        <Tooltip title={webservices} arrow>
          <div style={{ whiteSpace: 'nowrap' }}>
            <Box component="div" textOverflow="ellipsis" overflow="hidden">
              {webservices || '-'}
            </Box>
          </div>
        </Tooltip>
      );
    },
  },
  {
    title: 'وضعیت',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (row) => {
      return DescriptionStatus(row.status, row.descriptionSituation);
    },
  },

  ...(actionsList['editSubMyWebServiceListPage'] ? [{
    title: 'عملیات',
    field: 'operationSmall',
    filtering: false,
    sorting: false,
    align: 'right',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rowData) => (
      <TableItemActionsNew
        iconButton
        startIcon={<Icons icon="MoreHorizontal" color="#667585"  size="20" />}
        title=""
        otherMenus={[
          {
            title: 'ویرایش',
            isShow: !!actionsList['editSubMyWebServiceListPage'],
            disabled: ['accepted', 'deleted'].includes(rowData.status),
            onClick: () => navigate(`/services/service-set/${rowData.id}/edit`, { state: rowData }),
          },

          {
            title: ['pending', 'accepted'].includes(rowData.status)
              ? 'درخواست عدم انتشار'
              : 'درخواست انتشار',
            isShow: true,
            onClick: () => {
              if (['rejected', 'draft'].includes(rowData.status)) {
                requestPublish(rowData);
              } else {
                requestUnpublish(rowData);
              }
            },
            disabled: ['deleted', 'pending'].includes(rowData.status),
          },

        ]}
      />
    ),
  }] : []),
];

const generateData = (rows, query) => {
  const newData = rows?.map?.((row, key) => ({
    num: query?.page * query?.pageSize + key + 1,
    ...row,
  }));
  return newData;
};

export { columns, generateData };
